import Loader from "@/components/loader/index.vue";

export default {
	name: "Select",

	components: {
		Loader
	},

	props: {
		/**
		 * Categories ids that you
		 * want to be highlighted
		 */
		marked: {
			type: Array,
			default: () => []
		},

		value: {
			type: [Number, String],
			default: null
		},

		title: {
			type: String,
			default: ""
		},

		mode: {
			type: String,
			default: ""
		},

		resetScroll: {
			type: Boolean,
			default: false
		},
	},

	data() {
		return {
			visible: false,

			root: [],
			expanded: false,
			input: {},
			query: "",
			changed: false,
			searching: false,
			debouncedSearch: "",
			results: []
		}
	},

	computed: {
		/**
		 * List of categories
		 * 
		 * @returns {Array}
		 */
		list() {
			return this.expanded?.children?.length ? this.expanded.children : this.root;
		}
	},

	methods: {
		/**
		 * Check if the component belongs to aside component
		 * 
		 * @returns {Boolean}
		 */
		belongsToAsideComponent() {
			let vm = this;
			let items = [];
			while (vm) {
				items.unshift(vm);
				vm = vm.$parent;
			};
			return items.some(f => f === this.$components.aside);
		},

		/**
		 * Show
		 */
		show() {
			this.clear().visible = true;

			this.$nextTick(() => {
				if (this.resetScroll) {
					this.$refs.lightbox?.resetScroll();
				};
			});

			if (this.belongsToAsideComponent()) {
				const el = this.$components.aside.$el;
				el.classList.add("showing-lightbox");
			};

			this.$emit("onShow", this);
		},

		/**
		 * Hide
		 */
		hide() {
			this.visible = false;

			if (this.resetScroll) {
				this.$refs.lightbox?.resetScroll();
			};

			if (this.belongsToAsideComponent()) {
				const el = this.$components.aside.$el;
				el.classList.remove("showing-lightbox");
			};

			this.$emit("onHide", this);
		},

		/**
		 * Import children list
		 * 
		 * @param {Array[String]} ids 
		 */
		importChildren(ids) {
			return ids
				.filter(id => this.categories.items[id]/*  && this.$te_all(this.categories.items[id].name) */)
				.map(id => ({ ...this.categories.items[id] }))
				.sort((a, b) => (a.order ?? a.id) - (b.order ?? b.id));
		},

		/**
		 * Get parents of item
		 * 
		 * @param {Object} item
		 * @param {Boolean} current
		 * 
		 * @returns {Array}
		 */
		getParents(item, current) {
			let   pid = this.categories.items[item?.id ?? item]?.parent;
			const list = [];

			if (current) pid = item?.id;

			while(pid) {
				const parent = this.categories.items[pid];
				
				if (parent?.id) list.unshift(parent);

				pid = parent?.parent;
			}

			pid = null;

			return list;
		},

		/**
		 * Search in categories event
		 * 
		 * @param {Event} e
		 * 
		 * @returns {Void}
		 */
		searchEvent(e) {
			if (e?.keyCode === 13) e.preventDefault();
			if (
				e?.type === "click" 
				|| e?.type === "input" 
			) {
					this.input = this.$refs.search?.inputs?.[0];
					this.query = (this.input?.value || "").toLowerCase();
		
					this.debouncedSearch();
			}
		},

		/**
		 * Search in categories
		 * 
		 * @returns {Void}
		 */
		search() {
			// this.searching = true;
			this.results = [];

			if (this.query?.length) {
				/* Fist version of search */
				/*this.importChildren(Object.keys(this.categories.items)).forEach(item => {
					const value = this.$t(item.name).toLowerCase();

					if (value.includes(this.query)) {
						this.results.push({ ...item, history: this.getParents(item) });
					}
				}); */

				/* Second version of search */
				this.root.map(r => ({ ...r })).forEach(item => this.recursiveSearch(item));
			} 
			
			this.changed = this.query?.length;
			// setTimeout(() => this.searching = false, 1);
		},

		/**
		 * Clear search field
		 * 
		 * @returns {Void}
		 */
		clearEvent() {
			this.debouncedSearch.cancel();
			this.clear();
			this.input?.focus?.();
		},

		/**
		 * Recursively search in item and all children
		 * All children results will be in item.matched
		 * matched param only for inner usage
		 * 
		 * Collect all direct and children matches to results array
		 * 
		 * @param {Object} item
		 * @param {Array} matched
		 */
		recursiveSearch(item, matched) {
			const value = this.$t(item.name).toLowerCase();

			/* Search in item */
			if (value.includes(this.query)) {
				if (!matched) matched = item.matched = [];
				else matched.push(item);
			}

			/* Search in item children */
			if (item.children?.length) {
				item.children = this.importChildren(item.children);

				for (const child of item.children) {
					this.recursiveSearch(child, matched);
				}
			}

			/* Push item to results */
			if (item.matched) {
				this.results.push({ ...item, history: item.matched });
			}
		},

		/**
		 * Wrap matches in <mark>
		 * 
		 * @param {String} text
		 * 
		 * @returns {String}
		 */
		highlightMatches(text) {
			return text.replace(new RegExp(this.query, "ig"), match => {
				return `<mark>${ match }</mark>${ match.replace(match, '') }`;
			});
		},

		/**
		 * Clear search results
		 * 
		 * @returns {@Select}
		 */
		clear() {
			this.query = "";
			this.changed = false;
			this.searching = false;
			this.results = [];

			return this;
		},

		/**
		 * Expand selected item
		 * 
		 * @param {Number|String} id
		 */
		expand(id) {
			const
				item = this.categories.items[id],
				parent = this.categories.items[item?.parent];

			if (item?.id) {
				this.expanded = {
					...item,
					history: this.getParents(item, true),
					children: (() => {
						if (item.children?.length) {
							/* If item have children */
							return this.importChildren(item.children);
						} else if (parent?.children?.length) {
							/* If item haven't children, show list from parent */
							return this.importChildren(parent.children);
						} else {
							/* Show root categories */
							return [...this.root];
						}
					})()
				}
	
				this.clear();
			} else {
				this.expanded = false;
			}
		},

		selectionDisabled() {
			let result = false;
			if (this.mode === "offer") {
				result = true;
				const id = this.expanded?.id;
				if (id && !(this.categories.items[id]?.children?.length)) {
					result = false;
				};
			};
			return result;
		},

		/**
		 * Select item
		 */
		select() {
			const needSelect = this.expanded && !(this.isMarked(this.expanded?.id));
			if (needSelect) {
				this.$emit('selected', this.expanded?.id);
			}
			this.hide();
			this.expanded = false;
		},

		/**
		 * Check if given id in marked list
		 * 
		 * @param {Number|String} id
		 * 
		 * @returns {Boolean}
		 */
		isMarked(id) {
			return this.marked.some(d => Number(d) === Number(id));
		}
	},

	watch: {
		/**
		 * Watch for value changes
		 * 
		 * @param {Number|String} id
		 */
		value(id) {
			this.expand(id);
		}
	},

	created() {
		this.debouncedSearch = this.debounce(this.search, 500);
	},

	mounted() {
		this.root = this.importChildren(
			Object.entries(this.categories.items || {})
				.filter(f => !f[1].parent)
				.map(m => m[0])
		);

		if (this.value) this.expand(this.value);
	},

	beforeDestroy() {
		this.debouncedSearch?.cancel();
	},
}